// src/store/campaign/campaign.store.ts
import { create } from "zustand";
import type { TriggerType } from "src/types/campaign";

interface CampaignStore {
  triggerType?: TriggerType;
  page: number;
  size: number;
  sort: string;
  setQuery: (
    params: Partial<{
      triggerType?: TriggerType;
      page: number;
      size: number;
      sort: string;
    }>
  ) => void;
}

export const useCampaignStore = create<CampaignStore>((set) => ({
  triggerType: undefined,
  page: 1,
  size: 20,
  sort: "",
  setQuery: (params) => set((state) => ({ ...state, ...params })),
}));
